module.exports = __webpack_public_path__ + "img/transparent-pattern.2a59714d.svg";